import { render } from "./AddNote.vue?vue&type=template&id=5882d22e&scoped=true"
import script from "./AddNote.vue?vue&type=script&lang=js"
export * from "./AddNote.vue?vue&type=script&lang=js"

import "./AddNote.vue?vue&type=style&index=0&id=5882d22e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5882d22e"

export default script